import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { ModalHeader as c } from "./ModalHeader.js";
import { Breadcrumb as n } from "./Breadcrumb.js";
import { ModalFooter as p } from "./ModalFooter.js";
const h = ({
  children: a,
  isIO: l = !1,
  closeModal: m,
  title: o,
  genericTaggingEvent: d,
  cancelButtonAction: e,
  ...s
}) => /* @__PURE__ */ r("div", { className: "modal-rule-coupon-external", children: /* @__PURE__ */ i("div", { className: "modal-rule-coupon-internal", children: [
  /* @__PURE__ */ r(
    c,
    {
      closeModal: m,
      title: o,
      genericTaggingEvent: d
    }
  ),
  l && /* @__PURE__ */ r(n, { title: o, cancelButtonAction: e }),
  /* @__PURE__ */ r("div", { className: "modal-rule-coupon-children", children: a }),
  /* @__PURE__ */ r(
    p,
    {
      cancelButtonAction: e,
      ...s
    }
  )
] }) });
export {
  h as Modal
};
